import React, { forwardRef } from 'react';

const TranslateIconButton = forwardRef(({ style, className, onClick }, ref) => (
  <svg
    ref={ref}
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    style={style}
    className={className}
    onClick={onClick}
  >
    <path
      d="M819.2 316.416V819.2H316.416c20.992 59.392 77.312 102.4 144.384 102.4h460.8V460.8c0-66.56-43.008-122.88-102.4-144.384zM363.52 441.344h89.6l-45.056-97.28-44.544 97.28z"
      fill="#16796F"
    />
    <path
      d="M563.2 102.4H102.4v460.8c0 84.992 68.608 153.6 153.6 153.6h460.8V256c0-84.992-68.608-153.6-153.6-153.6z m-43.008 482.304l-36.352-78.336H334.336l-35.84 78.336H235.52l173.056-379.392 176.128 379.392h-64z"
      fill="#16796F"
    />
  </svg>
));

TranslateIconButton.displayName = 'TranslateIconButton';

export default TranslateIconButton;
